export const environment = {
  production: true,
  api_url: 'https://api2.kiosque-edu.com/v1',
  api_wpurl: 'https://api-cms.kiosque-edu.com',
  imgfolder_url: 'https://www.kiosque-edu.com/img'

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts